import { render, staticRenderFns } from "./PollResults.vue?vue&type=template&id=67a74f76&scoped=true"
import script from "./PollResults.vue?vue&type=script&lang=js"
export * from "./PollResults.vue?vue&type=script&lang=js"
import style0 from "./PollResults.vue?vue&type=style&index=0&id=67a74f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a74f76",
  null
  
)

export default component.exports